export function permitsAnalyticsForPath(pathname: string): boolean {
  let decodedPath: string;
  try {
    decodedPath = decodeURIComponent(pathname);
  } catch {
    // A malformed route is not worth risking disclosure of an invitation
    // fragment. Analytics may resume after navigation to a normal URL.
    return false;
  }

  const normalized = decodedPath.length > 1
    ? decodedPath.replace(/\/+$/, '').toLowerCase()
    : decodedPath.toLowerCase();
  return !/^\/(fitbit|ultrahuman)\/enroll(?:\/|$)/.test(normalized);
}
